import { useState, useEffect, SetStateAction, Dispatch } from 'react'
import authServices from '@/modules/Auth/auth-services'
import { IUserData } from '@/modules/Auth/auth-types'

type UseUserDataReturn = {
  loading: boolean
  error: unknown
  userData: IUserData
  setUserData: Dispatch<SetStateAction<IUserData>>
}

export const useUserData = (): UseUserDataReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [userData, setUserData] = useState<IUserData>()

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true)
        const data = await authServices.getUserData()

        setUserData(data)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
        setError(false)
      }
    }

    fetchUserData()
  }, [])

  return {
    loading,
    error,
    userData,
    setUserData,
  }
}
